// src/components/fare-calendar/fare-calendar.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(['\n  query FareCalendarQuery(\n    $context: ContextInput!\n    $journeyCriteria: [FlightsJourneyCriteriaInput!]!\n    $flightsSearchContext: FlightsSearchContextInput!\n  ) {\n    flightsFareCalendar(context: $context, journeyCriteria: $journeyCriteria, flightsSearchContext: $flightsSearchContext) {\n      disclaimerText\n      priceLockupText\n      coverageAnalytics {\n        linkName\n        referrerId\n      }\n      datePickerCellContents {\n        date {\n          formatted(format: "yyyy-MM-dd")\n        }\n        accessibility\n        selectAnalytics {\n          linkName\n          referrerId\n        }\n        content {\n          price {\n            amount\n            formatted\n          }\n          priceTheme\n          valueText\n        }\n      }\n    }\n  }\n']);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
import React3 from "react";
import debounce from "lodash.debounce";
import { DatePickerFooterAdditionalText } from "@egds/react-air-flexibility";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { useExperiment } from "@shared-ui/experiment-context";
import { useLocalization as useLocalization2 } from "@shared-ui/localization-context";
import { useLogger as useLogger2 } from "@shared-ui/logger-context";
import { UitkDatePicker } from "uitk-react-date-picker";
// src/components/fare-calendar/helpers/date-utils.ts
function dateToUTC(date) {
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
}
var TO_DAY_MULTIPLIER = 1e3 * 60 * 60 * 24;
function isValidDate(dateString) {
  return /^(\d{4})-(\d{2})-(\d{2})$/.test(dateString) || /^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\dZ$/.test(dateString);
}
function parseDate(dateString) {
  var parsedTimestamp = Date.parse(dateString);
  if (Number.isNaN(parsedTimestamp) || !isValidDate(dateString)) {
    throw Error("Failed to convert ".concat(dateString, " to a valid date."));
  }
  var timeZonedDate = new Date(dateString);
  return dateToUTC(timeZonedDate);
}
function getNDaysFrom(currentISODate, n) {
  var currentDate = parseDate(currentISODate);
  var isoDayBefore = parseDate(currentISODate);
  isoDayBefore.setDate(currentDate.getDate() + n);
  return isoDayBefore;
}
function getToday() {
  var todayAsDate = /* @__PURE__ */new Date();
  return new Date(todayAsDate.getFullYear(), todayAsDate.getMonth(), todayAsDate.getDate());
}
function calculateDayDiff(oldDate, newDate) {
  var dayDiff = Math.floor((newDate.getTime() - oldDate.getTime()) / TO_DAY_MULTIPLIER);
  return dayDiff > 0 ? "+".concat(dayDiff) : "".concat(dayDiff);
}
// src/components/fare-calendar/helpers/dialog-wrapper.tsx
import React from "react";
import { useDialog } from "@shared-ui/dialog-context";
import { UitkSheetTransition } from "uitk-react-sheet";
var useDialogWrapper = function () {
  var _useDialog = _sliced_to_array(useDialog("datepicker-start"), 3),
    startIsOpen = _useDialog[0],
    startDialogActions = _useDialog[1],
    StartDialogComponent = _useDialog[2];
  var _useDialog1 = _sliced_to_array(useDialog("datepicker-end"), 3),
    endIsOpen = _useDialog1[0],
    endDialogActions = _useDialog1[1],
    EndDialogComponent = _useDialog1[2];
  var dialogWrapper = function (children, dateType) {
    if (dateType === "end" /* END */) {
      return /* @__PURE__ */React.createElement(UitkSheetTransition, {
        isVisible: endIsOpen
      }, /* @__PURE__ */React.createElement(EndDialogComponent, null, /* @__PURE__ */React.createElement(React.Fragment, null, children)));
    }
    return /* @__PURE__ */React.createElement(UitkSheetTransition, {
      isVisible: startIsOpen
    }, /* @__PURE__ */React.createElement(StartDialogComponent, null, /* @__PURE__ */React.createElement(React.Fragment, null, children)));
  };
  var openDialog = function (dateType, isMobile) {
    if (isMobile) {
      if (dateType === "end" /* END */) {
        endDialogActions.openDialog();
      } else {
        startDialogActions.openDialog();
      }
    }
  };
  var dismissDialog = function (isMobile) {
    if (isMobile) {
      if (endIsOpen) {
        endDialogActions.closeDialog();
      } else {
        startDialogActions.closeDialog();
      }
    }
  };
  return [dialogWrapper, openDialog, dismissDialog];
};
// src/components/fare-calendar/helpers/use-analytics.ts
var getTrackingInfo = function (singleMode, dayDiff) {
  var tripType = singleMode ? "ONE_WAY" /* ONE_WAY */ : "ROUND_TRIP" /* ROUND_TRIP */;
  var onChangeEndDateCB = {
    id: "".concat(tripType, "_FC_onChangeEndDateCB"),
    description: "Returning date Change"
  };
  var onChangeMonthCB = {
    id: "".concat(tripType, "_FC_onChangeMonthCB"),
    description: "Month changed"
  };
  var onChangeStartDateCB = {
    id: "".concat(tripType, "_FC_onChangeStartDateCB"),
    description: "Departing date Change"
  };
  var onOpenCB = {
    id: "".concat(tripType, "_FC_onOpenCB"),
    description: "Open Date Picker"
  };
  var onDismissCB = {
    id: "".concat(tripType, "_FC_onDismissCB"),
    description: "Close Date Picker"
  };
  var onSubmitCB = {
    id: "".concat(tripType, "_FC_onSubmitCB"),
    description: "Save Dates"
  };
  var onDoneButtonCB = {
    id: "FLT.FareCalendar.Done",
    description: "Done Button Clicked"
  };
  var FlexDateTripType = singleMode ? "OW" /* FLEX_DATE_ONE_WAY */ : "RT" /* FLEX_DATE_ROUND_TRIP */;
  var onChangeFlexStartDateCB = {
    id: "FLT.".concat(FlexDateTripType, ".FareCalendar.DateChange.OB.").concat(dayDiff),
    description: "Outbound Date Change"
  };
  var onChangeFlexEndDateCB = {
    id: "FLT.".concat(FlexDateTripType, ".FareCalendar.DateChange.IB.").concat(dayDiff),
    description: "Inbound Date Change"
  };
  return {
    onChangeEndDateCB: onChangeEndDateCB,
    onChangeMonthCB: onChangeMonthCB,
    onChangeStartDateCB: onChangeStartDateCB,
    onOpenCB: onOpenCB,
    onDismissCB: onDismissCB,
    onSubmitCB: onSubmitCB,
    onDoneButtonCB: onDoneButtonCB,
    onChangeFlexStartDateCB: onChangeFlexStartDateCB,
    onChangeFlexEndDateCB: onChangeFlexEndDateCB
  };
};
// src/components/fare-calendar/helpers/use-fare-calendar.ts
import React2 from "react";
import { gql, useLazyQuery } from "@apollo/client";
import isEqual from "lodash.isequal";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useLocalization } from "@shared-ui/localization-context";
import { useLogger } from "@shared-ui/logger-context";
var __FareCalendarQuery = gql(_templateObject());
var useFareCalendar = function () {
  var _React2_useState = _sliced_to_array(React2.useState({
      datePickerContent: {},
      concatenatedResult: {}
    }), 2),
    resultData = _React2_useState[0],
    setResultData = _React2_useState[1];
  var _React2_useState1 = _sliced_to_array(React2.useState(""), 2),
    coverageAnalyticsReferrerId = _React2_useState1[0],
    setCoverageAnalyticsReferrerId = _React2_useState1[1];
  var _React2_useState2 = _sliced_to_array(React2.useState(""), 2),
    coverageAnalyticsLinkName = _React2_useState2[0],
    setCoverageAnalyticsLinkName = _React2_useState2[1];
  var _React2_useState3 = _sliced_to_array(React2.useState({}), 2),
    cellAnalyticsData = _React2_useState3[0],
    setCellAnalyticsData = _React2_useState3[1];
  var _React2_useState4 = _sliced_to_array(React2.useState({}), 2),
    amountAndValueText = _React2_useState4[0],
    setAmountAndValueText = _React2_useState4[1];
  var _React2_useState5 = _sliced_to_array(React2.useState(false), 2),
    isScrollQuery = _React2_useState5[0],
    setIsScrollQuery = _React2_useState5[1];
  var _React2_useState6 = _sliced_to_array(React2.useState(""), 2),
    footerText = _React2_useState6[0],
    setFooterText = _React2_useState6[1];
  var _React2_useState7 = _sliced_to_array(React2.useState(false), 2),
    showPriceLockup = _React2_useState7[0],
    setShowPriceLockup = _React2_useState7[1];
  var context = useBexApi().context;
  var formatDate = useLocalization().formatDate;
  var _useLogger = useLogger(),
    logError = _useLogger.error;
  var _useLazyQuery = _sliced_to_array(useLazyQuery(__FareCalendarQuery, {
      ssr: false,
      fetchPolicy: "no-cache"
    }), 2),
    getFareCalendarRatesLazy = _useLazyQuery[0],
    _useLazyQuery_ = _useLazyQuery[1],
    data = _useLazyQuery_.data,
    error = _useLazyQuery_.error;
  var adaptFareCalendarRates = function (response) {
    var datePickerContentData = {};
    var cellAnalytics = {};
    var amountAndValue = {};
    response.flightsFareCalendar.datePickerCellContents.map(function (item) {
      var _item_date;
      datePickerContentData[(_item_date = item.date) === null || _item_date === void 0 ? void 0 : _item_date.formatted] = {
        className: item.content.priceTheme.toLowerCase(),
        ariaLabel: item.accessibility,
        text: item.content.valueText
      };
      cellAnalytics[item.date.formatted] = {
        analytics: {
          referrerId: item.selectAnalytics.referrerId,
          linkName: item.selectAnalytics.linkName
        }
      };
      amountAndValue[item.date.formatted] = {
        price: item.content.price ? item.content.price.amount : item.content.valueText,
        priceWithCurrency: item.content.valueText
      };
      return [datePickerContentData, cellAnalytics, amountAndValue];
    });
    return [datePickerContentData, cellAnalytics, amountAndValue];
  };
  React2.useEffect(function () {
    setFooterText("");
    if (!isScrollQuery) {
      setResultData({
        datePickerContent: {},
        concatenatedResult: {}
      });
    }
    if (error) {
      logError("FARE_CALENDAR_FETCH_ERROR" /* FARE_CALENDAR_FETCH_ERROR */);
    }
    if ((data === null || data === void 0 ? void 0 : data.flightsFareCalendar) && data.flightsFareCalendar.datePickerCellContents.length > 0) {
      var _adaptFareCalendarRates = _sliced_to_array(adaptFareCalendarRates(data), 3),
        datePickerContentData = _adaptFareCalendarRates[0],
        cellAnalytics = _adaptFareCalendarRates[1],
        amountValue = _adaptFareCalendarRates[2];
      if (!isEqual(resultData.datePickerContent, datePickerContentData)) {
        setResultData({
          datePickerContent: datePickerContentData,
          concatenatedResult: isScrollQuery ? _object_spread({}, resultData.concatenatedResult, datePickerContentData) : datePickerContentData
        });
      }
      if (data.flightsFareCalendar.priceLockupText) {
        setShowPriceLockup(true);
        setFooterText(data.flightsFareCalendar.priceLockupText);
      } else {
        setShowPriceLockup(false);
        setFooterText(data.flightsFareCalendar.disclaimerText);
      }
      setCoverageAnalyticsReferrerId(data.flightsFareCalendar.coverageAnalytics.referrerId);
      setCoverageAnalyticsLinkName(data.flightsFareCalendar.coverageAnalytics.linkName);
      setCellAnalyticsData(cellAnalytics);
      setAmountAndValueText(amountValue);
    }
  }, [data, error, logError]);
  var resolveCalendarSearchDates = function (requestStartDate, outboundDateSelected) {
    var today = getToday();
    var departureDate = requestStartDate < today ? today : requestStartDate;
    var returnDate = departureDate;
    if (outboundDateSelected) {
      returnDate = getNDaysFrom(formatDate(requestStartDate, {
        raw: "yyyy-MM-dd"
      }), 14);
    }
    return {
      departureDate: departureDate,
      returnDate: returnDate
    };
  };
  var getFareCalendarRates = function (origin, destination, tripType, startDate, outboundDateSelected, isScrolled) {
    setIsScrollQuery(isScrolled);
    var _resolveCalendarSearchDates = resolveCalendarSearchDates(startDate, outboundDateSelected),
      departureDate = _resolveCalendarSearchDates.departureDate,
      returnDate = _resolveCalendarSearchDates.returnDate;
    var journeyCriteria = [{
      departureDate: {
        day: departureDate.getDate(),
        month: departureDate.getMonth() + 1,
        year: departureDate.getFullYear()
      },
      destination: destination,
      origin: origin
    }];
    if (departureDate !== returnDate) {
      journeyCriteria = [{
        departureDate: {
          day: departureDate.getDate(),
          month: departureDate.getMonth() + 1,
          year: departureDate.getFullYear()
        },
        destination: destination,
        origin: origin
      }, {
        departureDate: {
          day: returnDate.getDate(),
          month: returnDate.getMonth() + 1,
          year: returnDate.getFullYear()
        },
        destination: origin,
        origin: destination
      }];
    }
    var inputs = {
      context: context,
      journeyCriteria: journeyCriteria,
      flightsSearchContext: {
        tripType: tripType
      }
    };
    var variables = _object_spread_props(_object_spread({}, inputs), {
      context: context
    });
    getFareCalendarRatesLazy({
      variables: variables
    });
  };
  return [getFareCalendarRates, resultData.concatenatedResult, footerText, coverageAnalyticsReferrerId, coverageAnalyticsLinkName, cellAnalyticsData, amountAndValueText, showPriceLockup];
};
var useFareCalendarFetcher = function (origin, destination, tripType) {
  var _useFareCalendar = _sliced_to_array(useFareCalendar(), 8),
    getFareCalendarRates = _useFareCalendar[0],
    datePickerContentBex = _useFareCalendar[1],
    footerTextBex = _useFareCalendar[2],
    coverageAnalyticsReferrerId = _useFareCalendar[3],
    coverageAnalyticsLinkName = _useFareCalendar[4],
    cellAnalyticsData = _useFareCalendar[5],
    amountAndValueText = _useFareCalendar[6],
    showPriceLockup = _useFareCalendar[7];
  var refreshCalendarRates = function (departureDate, outboundDateSelected, isScrolled) {
    getFareCalendarRates(origin, destination, tripType, departureDate, outboundDateSelected, isScrolled);
  };
  return [refreshCalendarRates, datePickerContentBex, footerTextBex, coverageAnalyticsReferrerId, coverageAnalyticsLinkName, cellAnalyticsData, amountAndValueText, showPriceLockup];
};
// src/components/fare-calendar/fare-calendar.tsx
var DELAY = 1e3;
var TripType = /* @__PURE__ */function (TripType2) {
  TripType2["ONE_WAY"] = "ONE_WAY";
  TripType2["ROUND_TRIP"] = "ROUND_TRIP";
  TripType2["FLEX_DATE_ONE_WAY"] = "OW";
  TripType2["FLEX_DATE_ROUND_TRIP"] = "RT";
  return TripType2;
}(TripType || {});
var FieldName = /* @__PURE__ */function (FieldName2) {
  FieldName2["START_DATE"] = "startDate";
  FieldName2["END_DATE"] = "endDate";
  return FieldName2;
}(FieldName || {});
var formatDateToString = function (date, formatDate) {
  if (date) {
    return formatDate(date, {
      raw: "yyyy-MM-dd"
    });
  }
  return "";
};
var FareCalendarWrapped = function (props) {
  var destination = props.destination,
    dateFieldProps = props.dateFieldProps,
    endDate = props.endDate,
    firstDayOfWeek = props.firstDayOfWeek,
    onChange = props.onChange,
    onMountCB = props.onMountCB,
    origin = props.origin,
    singleMode = props.singleMode,
    startDate = props.startDate,
    tripType = props.tripType,
    onSubmitAnalytics = props.onSubmitAnalytics,
    dialogWrapper = props.dialogWrapper,
    openDialog = props.openDialog,
    dismissDialog = props.dismissDialog,
    onOpenCB = props.onOpenCB,
    autoOpen = props.autoOpen,
    onDoneButtonClickCB = props.onDoneButtonClickCB,
    singleTrigger = props.singleTrigger;
  var _useFareCalendarFetcher = _sliced_to_array(useFareCalendarFetcher(origin, destination, tripType), 8),
    refreshCalendarRates = _useFareCalendarFetcher[0],
    datePickerContent = _useFareCalendarFetcher[1],
    footerText = _useFareCalendarFetcher[2],
    coverageAnalyticsReferrerId = _useFareCalendarFetcher[3],
    coverageAnalyticsLinkName = _useFareCalendarFetcher[4],
    cellAnalyticsData = _useFareCalendarFetcher[5],
    amountAndValueText = _useFareCalendarFetcher[6],
    showPriceLockup = _useFareCalendarFetcher[7];
  var _React3_useState = _sliced_to_array(React3.useState(false), 2),
    showDatePicker = _React3_useState[0],
    setShowDatePicker = _React3_useState[1];
  var disableScrollRef = React3.useRef(false);
  var initialOpenRef = React3.useRef(false);
  var _React3_useState1 = _sliced_to_array(React3.useState(false), 2),
    isMobileState = _React3_useState1[0],
    setIsMobileState = _React3_useState1[1];
  var _React3_useState2 = _sliced_to_array(React3.useState(false), 2),
    startDateChanged = _React3_useState2[0],
    setStartDateChanged = _React3_useState2[1];
  var _React3_useState3 = _sliced_to_array(React3.useState(false), 2),
    outboundDateSelected = _React3_useState3[0],
    setOutboundDateSelected = _React3_useState3[1];
  var _React3_useState4 = _sliced_to_array(React3.useState(getToday()), 2),
    selectedStartDate = _React3_useState4[0],
    setSelectedStartDate = _React3_useState4[1];
  var _React3_useState5 = _sliced_to_array(React3.useState(getToday()), 2),
    selectedEndDate = _React3_useState5[0],
    setSelectedEndDate = _React3_useState5[1];
  var _React3_useState6 = _sliced_to_array(React3.useState(""), 2),
    currentPriceState = _React3_useState6[0],
    setCurrentPriceState = _React3_useState6[1];
  var formatDate = useLocalization2().formatDate;
  var analytics = getTrackingInfo(singleMode);
  var analyticsTracker = useClickTracker();
  var experimentUpdateResultsOnFsrWhenCalendarUsedError = "Update_results_on_FSR_when_calendar_used_v2_error";
  var _useExperiment = useExperiment("Update_results_on_FSR_when_calendar_used_v2", true),
    bexDoneButtonSearchExposure = _useExperiment.exposure,
    bexDoneButtonSearchLogger = _useExperiment.logExperiment;
  var _useExperiment1 = useExperiment("COMET_Update_results_on_FSR_when_calendar_is_used", true),
    cometDoneButtonSearchExposure = _useExperiment1.exposure,
    cometDoneButtonSearchLogger = _useExperiment1.logExperiment;
  var _useLogger2 = useLogger2(),
    logError = _useLogger2.error;
  var trackAnalytics = function (trackingInfo) {
    analyticsTracker(trackingInfo.id, trackingInfo.description);
  };
  var formatCurrentPrice = function (date) {
    var _amountAndValueText_formatDateToString;
    var selectedPrice = (_amountAndValueText_formatDateToString = amountAndValueText[formatDateToString(date, formatDate)]) === null || _amountAndValueText_formatDateToString === void 0 ? void 0 : _amountAndValueText_formatDateToString.priceWithCurrency;
    if (!selectedPrice || selectedPrice === "-") {
      setCurrentPriceState("");
    } else {
      setCurrentPriceState(selectedPrice);
    }
  };
  var onChangeMonthCB = function (event) {
    if (!(outboundDateSelected && tripType === "ROUND_TRIP" /* ROUND_TRIP */)) {
      refreshCalendarRates(event, outboundDateSelected, false);
    }
    trackAnalytics(analytics.onChangeMonthCB);
  };
  var onChangeStartDateCB = function (date) {
    setSelectedStartDate(date);
    if (singleMode) {
      formatCurrentPrice(date);
    }
    if (!singleMode) {
      if (selectedEndDate && date > selectedEndDate) {
        setSelectedEndDate(new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1));
        initialOpenRef.current = false;
      }
      setSelectedStartDate(date);
      setStartDateChanged(true);
      setOutboundDateSelected(true);
      refreshCalendarRates(date, true, false);
    }
    trackAnalytics(analytics.onChangeStartDateCB);
    var flexDateAnalytics = getTrackingInfo(singleMode, calculateDayDiff(selectedStartDate, date));
    trackAnalytics(flexDateAnalytics.onChangeFlexStartDateCB);
  };
  var onChangeEndDateCB = function (date) {
    setSelectedEndDate(date);
    setOutboundDateSelected(false);
    trackAnalytics(analytics.onChangeEndDateCB);
    var flexDateAnalytics = getTrackingInfo(singleMode, calculateDayDiff(selectedEndDate, date));
    trackAnalytics(flexDateAnalytics.onChangeFlexEndDateCB);
  };
  var onSelectEndModeCB = function () {
    if (!singleMode) {
      setOutboundDateSelected(true);
      refreshCalendarRates(selectedStartDate, true, false);
      formatCurrentPrice(selectedStartDate);
    }
  };
  var onSelectStartMode = function () {
    refreshCalendarRates(new Date(selectedStartDate.getFullYear(), selectedStartDate.getMonth(), 1), false, false);
    initialOpenRef.current = true;
    disableScrollRef.current = true;
  };
  var open = function (dateType, isMobile) {
    openDialog(dateType, isMobile);
    setIsMobileState(isMobile);
    formatCurrentPrice(startDate ? parseDate(startDate) : getToday());
    setShowDatePicker(true);
    trackAnalytics(analytics.onOpenCB);
    onOpenCB === null || onOpenCB === void 0 ? void 0 : onOpenCB(dateType);
    if (dateType === "end") {
      onSelectEndModeCB();
    } else {
      onSelectStartMode();
    }
  };
  var dismiss = function (isMobile) {
    dismissDialog(isMobile);
    trackAnalytics(analytics.onDismissCB);
    setShowDatePicker(false);
    disableScrollRef.current = false;
  };
  var save = function (start, end, isMobile) {
    if (start) {
      var _amountAndValueText_formattedStart, _amountAndValueText_formattedEnd;
      var formattedStart = formatDateToString(start, formatDate);
      var formattedEnd = formatDateToString(end, formatDate);
      var changedStartDate = {
        fieldName: "startDate" /* START_DATE */,
        value: formattedStart,
        price: (_amountAndValueText_formattedStart = amountAndValueText[formattedStart]) === null || _amountAndValueText_formattedStart === void 0 ? void 0 : _amountAndValueText_formattedStart.price
      };
      var changedEndDate = {
        fieldName: "endDate" /* END_DATE */,
        value: formattedEnd,
        price: (_amountAndValueText_formattedEnd = amountAndValueText[formattedEnd]) === null || _amountAndValueText_formattedEnd === void 0 ? void 0 : _amountAndValueText_formattedEnd.price
      };
      onChange([changedStartDate, changedEndDate]);
      setOutboundDateSelected(false);
      trackAnalytics(analytics.onSubmitCB);
    }
    if (onSubmitAnalytics) {
      if (coverageAnalyticsReferrerId && coverageAnalyticsLinkName) {
        analyticsTracker(coverageAnalyticsReferrerId, coverageAnalyticsLinkName);
      }
      var date = tripType === "ONE_WAY" /* ONE_WAY */ ? selectedStartDate : selectedEndDate;
      var dateFormatted = formatDateToString(date, formatDate);
      if (cellAnalyticsData && date && cellAnalyticsData[dateFormatted]) {
        analyticsTracker(cellAnalyticsData[dateFormatted].analytics.referrerId, cellAnalyticsData[dateFormatted].analytics.linkName);
      }
    }
    dismiss(isMobile);
  };
  var routerLinkWrapper = function (children) {
    return /* @__PURE__ */React3.createElement(React3.Fragment, null, children);
  };
  React3.useEffect(function () {
    setSelectedStartDate(startDate ? parseDate(startDate) : getToday());
    setSelectedEndDate(endDate ? parseDate(endDate) : getToday());
    formatCurrentPrice(startDate ? parseDate(startDate) : getToday());
  }, [startDate, endDate]);
  React3.useEffect(function () {
    if (autoOpen) {
      refreshCalendarRates(selectedStartDate, false, false);
      setShowDatePicker(true);
    }
  }, []);
  React3.useEffect(function () {
    if (!singleMode) {
      formatCurrentPrice(selectedEndDate);
    }
  }, [selectedEndDate, amountAndValueText]);
  var scrollHandler = debounce(function (date) {
    var dateFormatted = formatDateToString(date, formatDate);
    if (!outboundDateSelected && !disableScrollRef.current && !(datePickerContent === null || datePickerContent === void 0 ? void 0 : datePickerContent[dateFormatted]) && initialOpenRef.current) {
      refreshCalendarRates(date, outboundDateSelected, true);
    }
    if (disableScrollRef.current) {
      disableScrollRef.current = false;
    }
  }, DELAY);
  var datePickerFieldProps = _object_spread_props(_object_spread({}, dateFieldProps), {
    routerLinkWrapper: routerLinkWrapper,
    onChange: onChange,
    showDatePicker: dateFieldProps.showDatePicker ? dateFieldProps.showDatePicker : showDatePicker,
    endName: "endDate" /* END_DATE */,
    startName: "startDate" /* START_DATE */
  });
  var handleOnDoneButtonClickCB = function (sDate, eDate) {
    if (bexDoneButtonSearchExposure) {
      try {
        bexDoneButtonSearchLogger(bexDoneButtonSearchExposure);
      } catch (err) {
        logError(experimentUpdateResultsOnFsrWhenCalendarUsedError, err);
      }
    }
    if (cometDoneButtonSearchExposure) {
      try {
        cometDoneButtonSearchLogger(cometDoneButtonSearchExposure);
      } catch (err) {
        logError(experimentUpdateResultsOnFsrWhenCalendarUsedError, err);
      }
    }
    var isBexExperimentVariantEnabled = bexDoneButtonSearchExposure && bexDoneButtonSearchExposure.bucket === 1;
    var isCometExperimentVariantEnabled = cometDoneButtonSearchExposure && cometDoneButtonSearchExposure.bucket === 1;
    if (isBexExperimentVariantEnabled || isCometExperimentVariantEnabled) {
      dismiss(isMobileState);
      trackAnalytics(analytics.onDoneButtonCB);
      onDoneButtonClickCB === null || onDoneButtonClickCB === void 0 ? void 0 : onDoneButtonClickCB(sDate, eDate);
    } else {
      save(sDate, eDate, isMobileState);
    }
  };
  var formattedStartDate = formatDateToString(new Date(selectedStartDate.getFullYear(), selectedStartDate.getMonth(), selectedStartDate.getDate()), formatDate);
  var emptyStartDate = startDateChanged ? formattedStartDate : "";
  var datePickerProps = {
    buttonText: dateFieldProps.buttonText,
    currentPrice: currentPriceState,
    dateFieldProps: datePickerFieldProps,
    datePickerContent: datePickerContent,
    daysBookableInAdvance: 330,
    dialogWrapper: dialogWrapper,
    doubleMonths: true,
    singleDateSelect: true,
    endDate: endDate ? formatDateToString(new Date(selectedEndDate.getFullYear(), selectedEndDate.getMonth(), selectedEndDate.getDate()), formatDate) : "",
    firstDayOfWeek: firstDayOfWeek,
    footerText: footerText,
    singleMode: singleMode,
    midnightBookingOffset: 4,
    onDismissCB: dismiss,
    onOpenCB: open,
    onMountCB: onMountCB,
    onSubmitCB: save,
    onChangeMonthCB: onChangeMonthCB,
    onChangeStartDateCB: onChangeStartDateCB,
    onChangeEndDateCB: onChangeEndDateCB,
    startDate: startDate ? formattedStartDate : emptyStartDate,
    onSelectEndModeCB: onSelectEndModeCB,
    onScrollHandler: scrollHandler,
    onDoneButtonClickCB: handleOnDoneButtonClickCB,
    useSingleTrigger: singleTrigger
  };
  if (showPriceLockup) {
    return /* @__PURE__ */React3.createElement(DatePickerFooterAdditionalText, _object_spread({}, datePickerProps));
  }
  return /* @__PURE__ */React3.createElement(UitkDatePicker, _object_spread({}, datePickerProps));
};
var FareCalendar = function (props) {
  var _useDialogWrapper = _sliced_to_array(useDialogWrapper(), 3),
    dialogWrapper = _useDialogWrapper[0],
    openDialog = _useDialogWrapper[1],
    dismissDialog = _useDialogWrapper[2];
  return /* @__PURE__ */React3.createElement(FareCalendarWrapped, _object_spread({}, _object_spread_props(_object_spread({}, props), {
    dialogWrapper: dialogWrapper,
    openDialog: openDialog,
    dismissDialog: dismissDialog
  })));
};
export { FareCalendar, FieldName, TripType };